// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__F6dF1","buttons":"styles_buttons__9IfUV","divider":"styles_divider__x_5qR"};